import React from "react";
import { BuilderData, BuilderLine, StateToShow, Comparitor, BuilderToCompareData, WaterTye, UserDefinedDataset } from "../types";
import CriteriaComparisonSelector from "./CriteriaComparisonSelector";
import CriteriaContinousValueInput from "./CriteriaContinousValueInput";
import CriteriaDescreteValueDropdown from "./CriteriaDescreteValueDropdown";
import CriteriaDataEditor from "./CriteriaDataEditor";
import { ActionMeta, SingleValue } from "react-select";


// Type definitions remain the same...
type ComparitorOption = {
  value: Comparitor;
  label: string;
};

interface CriteriaSelectorPrompt {
  updateSelectors : (criteria_data: BuilderToCompareData) => Promise<void>;
  updateToDefault : () => void,
  handleCriteriaChange: (dataset_name: string, attribute_name: string, year: number | undefined, month: number | undefined, current_parameters: StateToShow) => Promise<void>,
  builderData: BuilderData,
  current_selected_index: number | null,
  setBuilderData: React.Dispatch<React.SetStateAction<BuilderData>>,
  setCurrentSelectedIndex: React.Dispatch<React.SetStateAction<number | null>>,
  setCurrentComparison: React.Dispatch<React.SetStateAction<Comparitor | null>>,
  setInputValues:  React.Dispatch<React.SetStateAction<(number | undefined)[] | number | string[] | undefined>>,
  user_data: UserDefinedDataset, 
  setShowUserDataset: (user_data: UserDefinedDataset, current_user_data: string | undefined) => void,
  setValidCalculate: React.Dispatch<React.SetStateAction<boolean>>,
  // Added new prop to hide action buttons when rendered in Builder
  hideActionButtons?: boolean;
  error: React.ReactNode;
}

const discrete_comparitors : ComparitorOption[] = [
  {value: 'keep', label: 'Keep'},
  {value: 'drop', label: 'Drop'}
]
const continous_comparitors : ComparitorOption[] = [
  {value: 'min', label: 'Min'},
  {value: 'max', label: 'Max'},
  {value: 'range', label: 'Range'}
]

const CriteriaSelector: React.FC<CriteriaSelectorPrompt> = ({  
  updateToDefault, updateSelectors, handleCriteriaChange,
  builderData, current_selected_index,
  setBuilderData, setCurrentSelectedIndex, setCurrentComparison, setInputValues,
   user_data,
  setShowUserDataset, setValidCalculate,
  error,
}) => {

  return (
    <div className="criteria-container"> 
        {/* Criterias */}

        <div className="criteria-list-container">
          <CriteriaDataEditor 
            setValidCalculate={setValidCalculate} 
            updateToDefault={updateToDefault} 
            setInputValues={setInputValues} 
            onUpdate={setBuilderData} 
            data={builderData} 
            updateSelectors={updateSelectors} 
            current_selected_index={current_selected_index} 
            setCurrentSelectedIndex={setCurrentSelectedIndex} 
            setCurrentComparison={setCurrentComparison} 
            handleCriteriaChange={handleCriteriaChange}
            setShowUserDataset={setShowUserDataset}
            user_data={user_data}
          />
        </div>

        <div>
          {error && <div className="mt-4">{error}</div>}
        </div>
    </div>
  );
};

export default CriteriaSelector;